import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d0f694f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-audio-view" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "nav-list" }
const _hoisted_4 = { class: "nav-list-item" }

import {ref, computed, onMounted, onUnmounted, watch, inject} from 'vue'
  import {useRoute, useRouter} from 'vue-router'
  import {useStore} from 'vuex'

  import IconButton from '@/components/inputs/IconButton.vue'
  import ContentSection from '@/components/ContentSection.vue'
  import BufferingNotification from '@/components/BufferingNotification.vue'

  import {t, hasT} from '@/lib/i18n.js'

  import {usePreloader} from '@/lib/preloader.js'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AudioView',
  setup(__props) {

  const {getAsset} = usePreloader()

  const store = useStore()
  const route = useRoute()
  const router = useRouter()
  const bus = inject('bus')

  const waiting = ref(true)
  const loading = ref(true)

  const meta = computed(() => {
    return route.meta
  })

  const titleKey = computed(() => {
    return `${meta.value.contentKey}.title`
  })

  const contentKey = computed(() => {
    return `${meta.value.contentKey}.content`
  })

  const hasTitle = computed(() => {
    return hasT(store, titleKey.value)
  })

  const hasContent = computed(() => {
    return hasT(store, contentKey.value)
  })

  const titleText = computed(() => {
    if (hasTitle.value) {
      return t(store, titleKey.value)
    }

    return ''
  })

  const contentText = computed(() => {
    if (hasContent.value) {
      return t(store, contentKey.value)
    }

    return ''
  })

  const continueText = computed(() => t(store, 'continue'))

  const onClick = () => {
    //const videoState = store.getters.videoStatus
    let audioState = store.state.trackingData.mediaKey

    const regex = /\/([^./]+)\./
    const match = audioState.match(regex)

    if (match && match[1]) {
      audioState = match[1]
    }

    bus.publish({
      event: 'TRACK',
      data: {
        action: '<location> - click next',
        label: audioState
      }
    })

    router.push(meta.value.nextRoute)
  }

  const audioPath = computed(() => {
    return meta.value.audioPath
  })

  let a

  let wanted = true

  const muted = computed(() => store.state.muted)

  onMounted(() => {
    getAsset({type: 'AUDIO', path: audioPath.value}).then((audio) => {
      if (wanted) {
        loading.value = false

        audio.loop = true
        audio.play()
        audio.muted = muted.value

        audio.addEventListener('waiting', () => {
          waiting.value = true
        })

        audio.addEventListener('playing', () => {
          waiting.value = false
        })

        a = audio
      }
    })

    store.commit('updateTrackingData', {
      isMedia: true,
      mediaType: 'audio',
      mediaKey: audioPath
    })
  })

  watch(muted, (value) => (a.muted = value))

  onUnmounted(() => {
    wanted = false

    if (a) {
      a.pause()
      a.currentTime = 0
    }

    store.commit('updateTrackingData', {
      isMedia: false,
      mediaType: null,
      mediaKey: null
    })
  })

  const globalPaused = computed(() => store.state.paused)

  watch(globalPaused, (value) => {
    if (value) {
      a.pause()
    } else {
      a.play()
    }
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(hasTitle))
      ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_unref(titleText)), 1))
      : _createCommentVNode("", true),
    (_unref(hasContent))
      ? (_openBlock(), _createBlock(ContentSection, {
          key: 1,
          class: "content",
          innerHTML: _unref(contentText)
        }, null, 8, ["innerHTML"]))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", _hoisted_4, [
        _createVNode(IconButton, {
          name: "submit",
          onClick: onClick
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(continueText)), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(BufferingNotification, {
      active: waiting.value || loading.value,
      class: "loading"
    }, null, 8, ["active"])
  ]))
}
}

})